module.exports = __webpack_public_path__ + "e31b9afb8424d08efbd27dec2eacbd0c.mp4";